import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: flex-end;
`;
